// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"8f83ddcb","49":"a0932972","120":"5469ae64","154":"a0ee68ad","164":"79103126","183":"95f972ce","239":"6e649cf4","328":"9687a5af","455":"19149fbb","461":"3feca866","821":"ab5e732e","830":"f6a5dae3","910":"a00e003b"}[chunkId] + ".chunk.js";
};